module.exports = __webpack_public_path__ + "img/ISO27001-en.bcde3318.png";